import { Injectable, inject } from "@angular/core";
import { IsWalletAvailableService } from "@app/core/wallet/domain/service/is-wallet-available.service";
import { catchError, Observable, of, shareReplay } from "rxjs";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: "root"
})
export class IsWalletAvailableUseCase {
    private readonly isWalletAvailableService = inject(IsWalletAvailableService);

    // Several callers (app init, nav bar, guard, checkout) ask for this at the
    // same time, so the result is shared for the whole session. Logout does a
    // hard reload, which clears it.
    private cachedResult$: Observable<boolean> | null = null;

    execute(): Observable<boolean> {
        if (!environment.IS_WALLET_ENABLED) {
            return of(false);
        }
        if (this.cachedResult$ == null) {
            this.cachedResult$ = this.isWalletAvailableService.execute().pipe(
                // In case of error, we don't know if the wallet should be available or not
                // so we hide it for prevention
                catchError(() => {
                    // Don't keep the fallback, so the next call retries
                    this.cachedResult$ = null;
                    return of(false);
                }),
                shareReplay(1)
            );
        }
        return this.cachedResult$;
    }
}
